import { Alert, BackHandler, Platform } from "react-native";
import { dispatch } from "../../../redux/store";
import { setLoggedOut } from "../../../redux/auth/authSlice";

export const handleBackButton = () => {
    Alert.alert(
      'Exit App',
      'Do you really want to exit?',
      [
        {
          text: 'Cancel',
          style: 'cancel',
        },
        {
          text: 'Start Over',
          onPress: () => {
            dispatch(setLoggedOut());
          },
        },
        {
          text: 'Exit',
          onPress: () => {
            BackHandler.exitApp();
          },
        },
      ],
      { cancelable: false }
    );

    // Returning false to prevent default back behavior
    return true;
};